// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import * as _ from 'lodash';
// COMPONENTS
import Select from 'react-select'
import { Form, Spinner, Modal, Button, Alert } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import BlockUi from 'react-block-ui';
import Flatpickr from "react-flatpickr";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
//SERVICES AND HELPERS
import * as jobTeamMembersService from "../../../../services/service/jobTeamMemberService";
import * as jobTimeSheetService from "../../../../services/service/jobTimeSheetService";
import * as helper from "../../../../helpers/helper";
import * as alert from "../../../../redux/alertSnackBarRedux";
import * as confirmModal from "../../../../redux/confirmModalRedux";
import constants from '../../../../constants/constants';
import { connect } from 'react-redux';

const JobTimeSheetPage = (props) => {
    const { auth, showAlert, showConfirmModal, hideConfirmModal, setProcessing, jobInfo } = props;
    const { jobId } = useParams();
    const initialState = {
        id: 0,
        userId: 0,
        jobId: jobId,
        dateTime: null,
        clockIn: true,
        isNa: false
    }
    const [loading, setLoading] = useState(false);
    const [formLeadId, setFormLeadId] = useState(jobInfo.formLeadId);
    const [isAdminProject, setIsAdminProject] = useState(false);
    const [jobTeamMembers, setJobTeamMembers] = useState([]);
    const [allTeamMembers, setAllTeamMembers] = useState([]);
    const [selectedTeamMember, setSelectedTeamMember] = useState(null);
    const [timeSheetModel, setTimeSheetModel] = useState(initialState);
    const [timeSheet, setTimeSheet] = useState([]);
    const [clockInDateTime, setClockInDateTime] = useState(null);
    const [updateTimeSheetModel, setUpdateTimeSheetModel] = useState({
        id: 0,
        clockIn: null,
        clockOut: null
    })
    const [groupedTimeList, setGroupedTimeList] = useState([]);
    const [isGroupedView, setIsGroupedView] = useState(true);
    const [timeEntryType, setTimeEntryType] = useState({ label: 'Single Entry', value: 'Single Entry' });
    const [multiError, setMultiError] = useState([]);
    const timeEntryOptions = ['Single Entry', 'Multi Clock In', 'Multi Clock Out'];

    useEffect(() => {
        checkAndSetIsAdminProject();
        fetchTimeSheet();
        fetchTeamMembers();
    }, [])

    useEffect(() => {
        setSelectedTeamMember(null);
        setTimeSheetModel(initialState);
        setJobTeamMembers([]);
        setLoading(true);
        determineUserListByType();
    }, [timeEntryType]);

    const checkAndSetIsAdminProject = () => {
        if (jobInfo && jobInfo.projectName) {
            let projectNumberToCheck = jobInfo.projectName.split('-')[1];
            setIsAdminProject(["0001", "0002", "0003"].includes(projectNumberToCheck));
        }
    }

    const fetchTimeSheet = () => {
        jobTimeSheetService.getJobTimeSheets(jobId).then(res => {
            setTimeSheet(res);
            if (res) {
                setGroupedTimeList(
                    _.chain(res)
                        // Group the elements of Array based on `color` property
                        .groupBy('date')
                        // `key` is group's name (color), `value` is the array of objects
                        .map((value, key) => ({ date: key, timeSheet: value }))
                        .value()
                );
            }
        }).catch(ex => { })
    }

    const determineUserListByType = () => {
        if (timeEntryType.value === "Single Entry") {
            setJobTeamMembers(allTeamMembers);
            setLoading(false);
            return;
        }

        jobTimeSheetService.getCurrentlyClockedInUserIds(jobId).then(res => {
            let members = [];
            if (timeEntryType.value === "Multi Clock Out") {
                res.forEach(x => {
                    members.push({ ...x, value: x.id, label: allTeamMembers.find(a => a.value === x.userId).label })
                });
            } else {
                let userIds = res.map(x => x.userId);
                members = allTeamMembers.filter(x => !userIds.includes(x.value));
            }

            setJobTeamMembers(members);
        })
            .catch(ex => { })
            .finally(() => setLoading(false))
    }

    const fetchTeamMembers = () => {
        setLoading(true);
        jobTeamMembersService.getJobTeamMembers(jobId).then(res => {
            let everyone = res.map(x => helper.setToOptionModel(x.name, x.userId));
            setJobTeamMembers(everyone);
            setAllTeamMembers(everyone);
        }).catch(ex => { })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        if (selectedTeamMember && timeEntryType.value === "Single Entry")
            checkIfUserShouldBeClockedInOrOut(selectedTeamMember.value);
    }, [selectedTeamMember])

    const checkIfUserShouldBeClockedInOrOut = (userId) => {
        jobTimeSheetService.isUserClockedIn(jobId, userId).then(res => {
            if (res) {
                setTimeSheetModel({ ...timeSheetModel, id: res.id, isNa: false });
                setClockInDateTime(res.clockIn)
            } else {
                setTimeSheetModel({ ...timeSheetModel, id: 0 })
                setClockInDateTime(null);
            }
        }).catch(ex => {
            console.log("Ex ", ex);
        })
    }

    const resetForm = () => {
        setTimeSheetModel(initialState);
        setSelectedTeamMember(null);
        setTimeEntryType({ label: 'Single Entry', value: 'Single Entry' });
    }

    const saveTimeSheet = () => {
        if (timeSheetModel.dateTime === null) {
            showAlert({ message: 'Please select date/time before you submit', variant: 'warning' })
            return;
        }
        if (clockInDateTime != null) {
            if (moment(clockInDateTime).isSameOrAfter(timeSheetModel.dateTime)) {
                showAlert({ message: 'Error! Clockout date cannot be before clock in date.', variant: 'warning' })

                return;
            }
        }

        setLoading(true);
        jobTimeSheetService.save({ ...timeSheetModel, dateTime: moment(timeSheetModel.dateTime).format("MM/DD/YYYY hh:mm a") }).then(res => {
            resetForm();
            fetchTimeSheet();
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => {
            setLoading(false);
        });
    }

    const deleteTimeEntry = (id) => {
        setProcessing();
        jobTimeSheetService.deleteTimeSheet(id).then(res => {
            fetchTimeSheet();
            showAlert({ message: res.message, variant: "success" });
        }).catch(ex => {
            showAlert({ message: ex.message, variant: "error" });
        }).finally(() => {
            hideConfirmModal();
        })
    }

    const fetchEntry = (id) => {
        jobTimeSheetService.getTimeSheet(id).then(res => {
            setUpdateTimeSheetModel(res);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: "error" });
        });
    }

    const hideUpdateModal = () => {
        setUpdateTimeSheetModel({
            id: 0,
            clockIn: null,
            clockOut: null
        })
    }

    const updateTimeEntry = () => {
        if (updateTimeSheetModel.clockIn != null && updateTimeSheetModel.clockOut != null) {
            if (moment(updateTimeSheetModel.clockIn).isSameOrAfter(updateTimeSheetModel.clockOut)) {
                showAlert({ message: 'Error! Clockout date cannot be before clock in date.', variant: 'warning' })

                return;
            }
        }

        jobTimeSheetService.update({
            ...updateTimeSheetModel,
            clockIn: moment(updateTimeSheetModel.clockIn).format("MM/DD/YYYY hh:mm a"),
            clockOut: updateTimeSheetModel.clockOut ? moment(updateTimeSheetModel.clockOut).format("MM/DD/YYYY hh:mm a") : null
        }).then(res => {
            fetchTimeSheet();
            showAlert({ message: res.message, variant: "success" });
        }).catch(ex => {
            showAlert({ message: ex.message, variant: "error" });
        }).finally(() => hideUpdateModal());
    }

    const submitMultiTimeEntry = async () => {
        if (timeSheetModel.dateTime === null) {
            showAlert({ message: 'Please select date/time before you submit', variant: 'warning' })
            return;
        }

        setLoading(true);
        let errorMessage = [];
        let successCount = 0;

        for await (let x of selectedTeamMember) {
            await jobTimeSheetService.save({
                id: x.id,
                userId: x.userId ? x.userId : x.value,
                jobId: jobId,
                dateTime: moment(timeSheetModel.dateTime).format("MM/DD/YYYY hh:mm a")
            }).then(res => {
                ++successCount;
            }).catch(ex => {
                errorMessage.push(ex.message.replace('Error! User', x.label))
            })
        }

        if (successCount === selectedTeamMember.length) {
            showAlert({ message: 'Success! Time entry for all users has been saved.', variant: 'success' })
        } else if (successCount > 0) {
            showAlert({ message: 'Some of the users time entry was successful. Please view the errors', variant: 'info' })
        } else {
            showAlert({ message: 'Error! None of the users time sheet was submitted. Please review the errors', variant: 'error' })
        }

        setMultiError(errorMessage);
        resetForm();
        fetchTimeSheet();
        setLoading(false);
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                display: auth.isAdmin,
                sort: false,
                width: 1,
                print: false,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {
                                timeSheet[dataIndex].clockOut &&
                                <button
                                    type="button"
                                    onClick={() => fetchEntry(timeSheet[dataIndex].id)}
                                    className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                                >
                                    Edit
                                </button>
                            }
                            {' '}
                            <button
                                type="button"
                                onClick={() => showConfirmModal({
                                    title: "Delete Time Entry",
                                    text: "Are you sure you want to delete this time entry?",
                                    rightBtnText: "Confirm",
                                    btnAction: () => deleteTimeEntry(timeSheet[dataIndex].id)
                                })}
                                className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5"
                            >
                                Delete
                            </button>
                        </>
                    );
                }
            },
        },
        {
            name: "name",
            label: "User",
            options: {
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div className="tc-user-block">
                            <div
                                className="img-block background-image-container"
                                style={{ backgroundImage: `url(${timeSheet[dataIndex].imageUrl ? (constants.API_URL + timeSheet[dataIndex].imageUrl) : ("/media/users/default.jpg")})` }}
                            >
                            </div>

                            <div className="user-info-block">
                                <Link to={"/management/user-profile/" + timeSheet[dataIndex].userId} className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                    {timeSheet[dataIndex].name}
                                </Link>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "clockIn",
            label: "ClockIn",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <p>{moment(timeSheet[dataIndex].clockIn).format("HH:mm, MM/DD/YYYY")}</p>
                    );
                }
            }
        },
        {
            name: "clockOut",
            label: "Clock Out",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        timeSheet[dataIndex].clockOut ?
                            <p>{moment(timeSheet[dataIndex].clockOut).format("HH:mm, MM/DD/YYYY")}</p>
                            : <p>-</p>
                    );
                }
            }
        },
        {
            name: "id",
            label: "Total Hours",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    if (timeSheet[dataIndex].clockOut) {
                        var duration = moment.duration(moment(timeSheet[dataIndex].clockOut).diff(timeSheet[dataIndex].clockIn));

                        // duration in hours
                        var hours = parseInt(duration.asHours());

                        // duration in minutes
                        var minutes = parseInt(duration.asMinutes()) % 60;

                        return (
                            <p>{hours + ' hour and ' + minutes + ' minutes'}</p>
                        );
                    }

                    return <p>-</p>
                }
            }
        },
        // {
        //     name: "cost",
        //     label: "Cost",
        //     options: {
        //         filter: true,
        //         filterType: 'multiselect',
        //         sort: true,
        //         customBodyRenderLite: (dataIndex) => {
        //             return (
        //                 <p>${(timeSheet[dataIndex].cost).toFixed(2)}</p>
        //             );
        //         }
        //     }
        // },
        // {
        //     name: "total",
        //     label: "Total",
        //     options: {
        //         filter: true,
        //         filterType: 'multiselect',
        //         sort: true,
        //         customBodyRenderLite: (dataIndex) => {
        //             return (
        //                 <p>${(timeSheet[dataIndex].total).toFixed(2)}</p>
        //             );
        //         }
        //     }
        // },
    ];

    return (
        <div className="card card-custom" >
            <div className="card-header py-3">
                <div className="card-title align-items-start flex-column">
                    <h3 className="card-label font-weight-bolder text-dark">
                        Time Sheet
                    </h3>
                    <span className="text-muted font-weight-bold fz-xs mt-1">
                        View and Manage Time Sheet for Team members
                    </span>
                </div>
                <div className="card-toolbar">
                    <Link
                        to="/services/jobs"
                        className="btn btn-secondary"
                    >
                        Cancel
                    </Link>
                </div>
            </div>

            <Modal size='lg' show={updateTimeSheetModel.id > 0} onHide={hideUpdateModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Time Entry</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-lg-6 col-xl-6">
                            <Form.Group>
                                <Form.Label>Clock In Date/Time</Form.Label>
                                <Flatpickr
                                    placeholder="MM/DD/YYYY HH:MM"
                                    options={{
                                        enableTime: true,
                                        dateFormat: "m/d/Y H:i",
                                        time_24hr: true,
                                        static: true
                                    }}
                                    value={moment(updateTimeSheetModel.clockIn).format("MM/DD/YYYY HH:mm")}
                                    onChange={date => {
                                        setUpdateTimeSheetModel({ ...updateTimeSheetModel, clockIn: date[0] })
                                    }}
                                    className="form-control form-control-lg form-control-solid"
                                />
                            </Form.Group>
                        </div>
                        <div className="col-lg-6 col-xl-6">
                            <Form.Group>
                                <Form.Label>Clock Out Date/Time</Form.Label>
                                <Flatpickr
                                    placeholder="MM/DD/YYYY HH:MM"
                                    options={{
                                        enableTime: true,
                                        dateFormat: "m/d/Y H:i",
                                        time_24hr: true,
                                        static: true
                                    }}
                                    value={moment(updateTimeSheetModel.clockOut).format("MM/DD/YYYY HH:mm")}
                                    onChange={date => {
                                        setUpdateTimeSheetModel({ ...updateTimeSheetModel, clockOut: date[0] })
                                    }}
                                    className="form-control form-control-lg form-control-solid"
                                />
                            </Form.Group>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={updateTimeEntry}>
                        Save Changes
                    </Button>
                    <Button variant="secondary" onClick={hideUpdateModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>




            <BlockUi tag="div" blocking={loading}>
                <div className="form">
                    <div className="card-body">
                        <div className="row d-flex col-lg-12 col-xl-12">
                            {
                                isAdminProject ? (auth.isAdmin &&
                                    <>
                                        <div className="col-lg-2 col-xl-2">
                                            <Form.Group>
                                                <Form.Label>Time Entry Type</Form.Label>
                                                <Select
                                                    value={timeEntryType}
                                                    options={timeEntryOptions.map(x => {
                                                        return {
                                                            label: x,
                                                            value: x
                                                        }
                                                    })}
                                                    onChange={(selectedOption) => {
                                                        setTimeEntryType(selectedOption);
                                                    }}
                                                    name="type"
                                                    placeholder="Select Type"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-5 col-xl-5">
                                            <Form.Group>
                                                <Form.Label>Team Member</Form.Label>
                                                <Select
                                                    value={selectedTeamMember}
                                                    options={jobTeamMembers}
                                                    closeMenuOnSelect={timeEntryType.value === "Single Entry"}
                                                    onChange={(selectedOption) => {
                                                        setSelectedTeamMember(selectedOption);
                                                        if (timeEntryType.value === "Single Entry") {
                                                            setTimeSheetModel({ ...timeSheetModel, userId: selectedOption.value })
                                                        }
                                                    }}
                                                    isMulti={timeEntryType.value !== "Single Entry"}
                                                    name="teamMember"
                                                    placeholder="Select Team Member"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-5 col-xl-5">
                                            <Form.Group>
                                                <Form.Label>Clock Date/Time</Form.Label>
                                                <Flatpickr
                                                    placeholder="MM/DD/YYYY HH:MM"
                                                    options={{
                                                        enableTime: true,
                                                        dateFormat: "m/d/Y H:i",
                                                        time_24hr: true,
                                                    }}
                                                    value={timeSheetModel.dateTime}
                                                    onChange={date => {
                                                        setTimeSheetModel({ ...timeSheetModel, dateTime: date[0] })
                                                    }}
                                                    className="form-control form-control-lg form-control-solid"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="row col-lg-12 col-xl-12 search-clear-btn-group mt-lg-5 flex-row-reverse mb-lg-10">

                                            <button className="btn btn-secondary font-weight-bolder font-size-sm mr-3" onClick={resetForm}>
                                                Clear
                                            </button>
                                            {
                                                timeEntryType.value === "Single Entry" ?
                                                    <>
                                                        <button
                                                            disabled={timeSheetModel.id === 0}
                                                            className="btn btn-danger font-weight-bolder font-size-sm mr-3"
                                                            onClick={saveTimeSheet}
                                                        >
                                                            Clock Out
                                                        </button>
                                                        {' '}
                                                        <button
                                                            disabled={timeSheetModel.id !== 0}
                                                            className="btn btn-success font-weight-bolder font-size-sm mr-3"
                                                            onClick={saveTimeSheet}
                                                        >
                                                            Clock In
                                                        </button>
                                                        {' '}
                                                    </>
                                                    :
                                                    <>
                                                        <button
                                                            disabled={!selectedTeamMember}
                                                            className="btn btn-primary font-weight-bolder font-size-sm mr-3"
                                                            onClick={submitMultiTimeEntry}
                                                        >
                                                            {timeEntryType.value}
                                                        </button>
                                                    </>
                                            }
                                        </div>
                                    </>
                                ) :
                                    ((auth.isAdmin || formLeadId === auth.user.id) &&
                                        <>
                                            <div className="col-lg-2 col-xl-2">
                                                <Form.Group>
                                                    <Form.Label>Time Entry Type</Form.Label>
                                                    <Select
                                                        value={timeEntryType}
                                                        options={timeEntryOptions.map(x => {
                                                            return {
                                                                label: x,
                                                                value: x
                                                            }
                                                        })}
                                                        onChange={(selectedOption) => {
                                                            setTimeEntryType(selectedOption);
                                                        }}
                                                        name="type"
                                                        placeholder="Select Type"
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-lg-5 col-xl-5">
                                                <Form.Group>
                                                    <Form.Label>Team Member</Form.Label>
                                                    <Select
                                                        value={selectedTeamMember}
                                                        options={jobTeamMembers}
                                                        closeMenuOnSelect={timeEntryType.value === "Single Entry"}
                                                        onChange={(selectedOption) => {
                                                            setSelectedTeamMember(selectedOption);
                                                            if (timeEntryType.value === "Single Entry") {
                                                                setTimeSheetModel({ ...timeSheetModel, userId: selectedOption.value })
                                                            }
                                                        }}
                                                        isMulti={timeEntryType.value !== "Single Entry"}
                                                        name="teamMember"
                                                        placeholder="Select Team Member"
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-lg-5 col-xl-5">
                                                <Form.Group>
                                                    <Form.Label>Clock Date/Time</Form.Label>
                                                    <Flatpickr
                                                        placeholder="MM/DD/YYYY HH:MM"
                                                        options={{
                                                            enableTime: true,
                                                            dateFormat: "m/d/Y H:i",
                                                            time_24hr: true,
                                                        }}
                                                        value={timeSheetModel.dateTime}
                                                        onChange={date => {
                                                            setTimeSheetModel({ ...timeSheetModel, dateTime: date[0] })
                                                        }}
                                                        className="form-control form-control-lg form-control-solid"
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="row col-lg-12 col-xl-12 search-clear-btn-group mt-lg-5 flex-row-reverse mb-lg-10">

                                                <button className="btn btn-secondary font-weight-bolder font-size-sm mr-3" onClick={resetForm}>
                                                    Clear
                                                </button>
                                                {
                                                    timeEntryType.value === "Single Entry" ?
                                                        <>
                                                            <button
                                                                disabled={timeSheetModel.id === 0}
                                                                className="btn btn-danger font-weight-bolder font-size-sm mr-3"
                                                                onClick={saveTimeSheet}
                                                            >
                                                                Clock Out
                                                            </button>
                                                            {' '}
                                                            <button
                                                                disabled={timeSheetModel.id !== 0}
                                                                className="btn btn-success font-weight-bolder font-size-sm mr-3"
                                                                onClick={saveTimeSheet}
                                                            >
                                                                Clock In
                                                            </button>
                                                            {' '}
                                                        </>
                                                        :
                                                        <>
                                                            <button
                                                                disabled={!selectedTeamMember}
                                                                className="btn btn-primary font-weight-bolder font-size-sm mr-3"
                                                                onClick={submitMultiTimeEntry}
                                                            >
                                                                {timeEntryType.value}
                                                            </button>
                                                        </>
                                                }
                                            </div>
                                        </>
                                    )
                            }
                            {
                                multiError.length > 0 &&
                                <div className="col-lg-12 col-xxl-12">
                                    <Alert variant="danger" onClose={() => setMultiError([])} dismissible>
                                        <Alert.Heading>Error!</Alert.Heading>
                                        <ul>
                                            {
                                                multiError.map(x => (
                                                    <li>{x}</li>
                                                ))
                                            }
                                        </ul>
                                    </Alert>

                                </div>
                            }
                            <div className="col-lg-12 col-xxl-12" style={{ 'zIndex': 0 }}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={isGroupedView}
                                            onChange={() => {
                                                setIsGroupedView(!isGroupedView)
                                            }}
                                            value="checkedB"
                                            color="primary"
                                        />
                                    }
                                    label="Grouped View"
                                />
                                {
                                    isGroupedView ?
                                        groupedTimeList.map((x, index) => (
                                            <ExpansionPanel name={index}>
                                                <ExpansionPanelSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography>{x.date} - ({x.timeSheet.length} entries)</Typography>
                                                </ExpansionPanelSummary>
                                                <ExpansionPanelDetails>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Actions</TableCell>
                                                                <TableCell align="right">User</TableCell>
                                                                <TableCell align="right">ClockIn</TableCell>
                                                                <TableCell align="right">Clock Out</TableCell>
                                                                <TableCell align="right">Total Hours</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {x.timeSheet.map((row, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell component="th" scope="row">
                                                                        {
                                                                            isAdminProject ? (auth.isAdmin &&
                                                                                <>
                                                                                    {
                                                                                        row.clockOut &&
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={() => fetchEntry(row.id)}
                                                                                            className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                                                                                        >
                                                                                            Edit
                                                                                        </button>
                                                                                    }
                                                                                    {' '}
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => showConfirmModal({
                                                                                            title: "Delete Time Entry",
                                                                                            text: "Are you sure you want to delete this time entry?",
                                                                                            rightBtnText: "Confirm",
                                                                                            btnAction: () => deleteTimeEntry(row.id)
                                                                                        })}
                                                                                        className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5"
                                                                                    >
                                                                                        Delete
                                                                                    </button>
                                                                                </>
                                                                            ) :
                                                                                (auth.isAdmin || formLeadId === auth.user.id) &&
                                                                                (
                                                                                    <>
                                                                                        {
                                                                                            row.clockOut &&
                                                                                            <button
                                                                                                type="button"
                                                                                                onClick={() => fetchEntry(row.id)}
                                                                                                className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                                                                                            >
                                                                                                Edit
                                                                                            </button>
                                                                                        }
                                                                                        {' '}
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={() => showConfirmModal({
                                                                                                title: "Delete Time Entry",
                                                                                                text: "Are you sure you want to delete this time entry?",
                                                                                                rightBtnText: "Confirm",
                                                                                                btnAction: () => deleteTimeEntry(row.id)
                                                                                            })}
                                                                                            className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5"
                                                                                        >
                                                                                            Delete
                                                                                        </button>
                                                                                    </>
                                                                                )
                                                                        }

                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        <div className="tc-user-block">
                                                                            <div
                                                                                className="img-block background-image-container"
                                                                                style={{ backgroundImage: `url(${row.imageUrl ? (constants.API_URL + row.imageUrl) : ("/media/users/default.jpg")})` }}
                                                                            >
                                                                            </div>

                                                                            <div className="user-info-block">
                                                                                <Link to={"/management/user-profile/" + row.userId} className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                                                                    {row.name}
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        {moment(row.clockIn).format("HH:mm, MM/DD/YYYY")}
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        {row.clockOut ? moment(row.clockOut).format("HH:mm, MM/DD/YYYY") : "-"}
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        {
                                                                            (row.clockOut) ?
                                                                                parseInt(moment.duration(moment(row.clockOut).diff(row.clockIn)).asHours())
                                                                                + ' hour and ' +
                                                                                parseInt(moment.duration(moment(row.clockOut).diff(row.clockIn)).asMinutes() % 60)
                                                                                + ' minutes'
                                                                                : "-"
                                                                        }
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </ExpansionPanelDetails>
                                            </ExpansionPanel>
                                        ))
                                        :
                                        <MUIDataTable
                                            data={timeSheet}
                                            columns={columns}
                                            options={{
                                                rowsPerPage: 25,
                                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                                filter: false,
                                                selectableRows: 'none',
                                                downloadOptions: {
                                                    filename: 'job_time_sheet.csv',
                                                    filterOptions: {
                                                        useDisplayedColumnsOnly: true,
                                                        useDisplayedRowsOnly: true
                                                    }
                                                },
                                                textLabels: {
                                                    body: {
                                                        noMatch: loading ?
                                                            <Spinner animation="border" size="lg" variant="info" /> :
                                                            'Sorry, no matching records found.',
                                                    },
                                                }
                                            }}
                                        />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </BlockUi>
        </div>
    )
}

const mapStateToProps = (state) => ({
    userProfileState: state.userProfile,
    auth: state.auth
});

export default connect(mapStateToProps, { ...alert.actions, ...confirmModal.actions })(JobTimeSheetPage);